import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingFarms = function () { return utilBalancing.getBalancing().Farms; };
export var selectBalancingFarmsByFarmId = function (id) {
    return selectBalancingFarms().find(function (base) { return base.id === id; });
};
export var balancingFarmsMemoizedFunctions = [selectBalancingFarms, selectBalancingFarmsByFarmId];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingFarms.ts
// module id = 675
// module chunks = 3